import React from 'react';
import { Link } from 'react-router-dom';
import { theme } from '../theme';

const faqs: { q: string; a: React.ReactNode }[] = [
  {
    q: '¿Futbolero es gratis?',
    a: 'Sí. Organizar partidos, anotarte, armar equipos y dejar reviews es 100% gratis para jugadores.',
  },
  {
    q: '¿Necesito instalar una app?',
    a: 'No es obligatorio. Funciona desde el navegador en celular o computadora, y también tenemos app nativa disponible en iOS y Android para una mejor experiencia.',
  },
  {
    q: '¿Cómo organizo un partido?',
    a: 'Iniciás sesión, tocás "Crear Partido", elegís fecha, lugar y cantidad de jugadores, y compartís el link. Los jugadores se anotan solos.',
  },
  {
    q: '¿Cómo se arman los equipos?',
    a: 'Futbolero arma equipos balanceados automáticamente usando el nivel de cada jugador (basado en las reviews recibidas en partidos anteriores).',
  },
  {
    q: '¿Cómo funcionan las reviews?',
    a: 'Después del partido cada jugador puede dejar reviews a los demás con tags positivos, negativos o personalizados. Es anónimo y rápido.',
  },
  {
    q: '¿Puedo reservar canchas desde Futbolero?',
    a: 'Todavía no. El módulo de reservas de cancha está en desarrollo y lo vamos a habilitar pronto.',
  },
  {
    q: 'Tengo otra pregunta',
    a: (
      <>
        Escribinos a{' '}
        <a href="mailto:futboleroapp@gmail.com" style={{ color: theme.colors.primary }}>
          futboleroapp@gmail.com
        </a>{' '}
        y te respondemos.
      </>
    ),
  },
];

const FAQPage: React.FC = () => {
  return (
    <div
      style={{
        backgroundColor: theme.colors.background,
        minHeight: '100vh',
        color: theme.colors.text,
        fontFamily: theme.fonts.body,
        padding: '24px 16px 48px',
      }}
    >
      <div style={{ maxWidth: '720px', margin: '0 auto' }}>
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            color: theme.colors.primary,
            textDecoration: 'none',
            fontSize: theme.fonts.sizeBody,
            marginBottom: '24px',
          }}
        >
          ← Volver al inicio
        </Link>

        <h1
          style={{
            fontFamily: theme.fonts.heading,
            fontSize: '2rem',
            fontWeight: 700,
            marginBottom: '8px',
            color: theme.colors.text,
          }}
        >
          Preguntas frecuentes
        </h1>
        <p
          style={{
            color: theme.colors.textSecondary,
            marginBottom: '32px',
            fontSize: theme.fonts.sizeSmall,
          }}
        >
          Lo más consultado por la comunidad
        </p>

        {faqs.map(({ q, a }, i) => (
          <section key={i} style={{ marginBottom: '28px' }}>
            <h2
              style={{
                fontSize: '1.15rem',
                fontWeight: 700,
                color: theme.colors.primary,
                marginBottom: '12px',
              }}
            >
              {q}
            </h2>
            <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, margin: 0 }}>{a}</p>
          </section>
        ))}
      </div>
    </div>
  );
};

export default FAQPage;
